import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';
import globalContext from '../../../../config/context';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 300,
  },
  comboBox: {
    width: '100%',
    paddingBottom: 10,
    disabled: 'true',
  },
  textField: {
    width: '100%',
    paddingBottom: 10,
  },
}));

const DialogZnt = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{pencarian}, {setPencarian, setAlert, setLoading}] = useAppContext();

  const {
    tahun,
    setTahun,
    kecamatan,
    setKecamatan,
    kecamatanOptions,
    handleKecamatan,
    itemKecamatan,
    kelurahan,
    setKelurahan,
    kelurahanOptions,
    handleKelurahan,
    itemKelurahan,
    onZnt,
  } = props;

  // console.log(pencarian.kecamatan);
  // console.log(pencarian.kelurahan);

  useEffect(() => {
    if (pencarian.kecamatan) {
      setKecamatan(pencarian.kecamatan);
    }
    if (pencarian.kelurahan) {
      setKelurahan(pencarian.kelurahan);
    }
  }, [pencarian.kecamatan, setKecamatan, pencarian.kelurahan, setKelurahan]);

  return (
    <div className={classes.root}>
      <Autocomplete
        id="combo-box-kecamatan"
        className={classes.comboBox}
        options={itemKecamatan}
        getOptionLabel={(option) => (option ? option.kd_kecamatan + ' - ' + option.nm_kecamatan : '')}
        value={kecamatanOptions}
        onChange={handleKecamatan}
        renderInput={(params) => <TextField {...params} label="Kecamatan" variant="outlined" />}
      />

      <Autocomplete
        id="combo-box-kelurahan"
        className={classes.comboBox}
        disabled={kecamatan === '' ? true : false}
        options={itemKelurahan}
        getOptionLabel={(option) => (option ? option.kd_kelurahan + ' - ' + option.nm_kelurahan : '')}
        value={kelurahanOptions}
        onChange={handleKelurahan}
        renderInput={(params) => <TextField {...params} label="Kelurahan" variant="outlined" />}
      />

      <TextField
        id="standard-number"
        className={classes.textField}
        label="Tahun"
        variant="outlined"
        type="number"
        disabled={kelurahan === '' ? true : false}
        value={tahun ? tahun : pencarian.tahun}
        onChange={(e) => setTahun(e.target.value)}
        onInput={(e) => {
          e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 4);
        }}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onZnt();
          }
        }}
      />
    </div>
  );
};

export default DialogZnt;
